import styled from "styled-components";

export const ContainerInner = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  justify-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const Logo = styled.img`
  width: 50%;
  max-width: 500px;
  grid-row: 2;
`;

export const Canvas = styled.canvas`
  background-color: #121212;
  border-radius: 16px;
  width: 100%;
  height: 100%;
`;

export const LogoAgency = styled.img`
  transition: 0.3s;
  object-fit: contain;
  &:hover {
    filter: opacity(0.5);
  }
`;

export const ContainerLogos = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-top: auto;
  padding-block: 16px;
  grid-row: 3;
`;

export const SubContainerLogos = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const EdgLogo = styled.img`
  width: 100%;
  max-width: 300px;
  object-fit: contain;
  transition: 0.3s;
  filter: invert(1);
  &:hover {
    filter: invert(0.5);
  }
`;

export const AgencyLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
`;
